import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Col, Row } from "reactstrap";
import Carousel from "../../components/Carousel";

const JumboCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Carousel className="main_slider" settings={settings}>
      <div className="main_jumbotron bg-coral">
        {/* <Row>
          <Col md={7} sm={12}>
            <h1 className="mb-3">
              해외 명문대 진학을 위한
              <br /> 프리미엄 비대면 서비스
            </h1>
            <p>1:1 맞춤형 컨설팅, 온라인 멘토링, 원서지원관리</p>
          </Col>
          <Col md={5} sm={12} className="text-center">
            <img
              src={require("../../assets/img/jumbo2.png")}
              className="img-fluid"
              alt="jumbo2"
            />
          </Col>
        </Row> */}
      </div>
      <div className="main_jumbotron bg-img">
        <a href="/page/class/alevel">
          <div className="bg-img-premium-responsive"></div>
        </a>
      </div>
      <div className="main_jumbotron bg-blue">
        {/* <Row>
          <Col md={7} sm={12}>
            <h1 className="mb-3">
              해외 곳곳에 위치한 <br />
              명문대출신 강사들
            </h1>
            <p>위치 제약 없이 / 저렴한 가격에 / 1:1 온라인 수업</p>
          </Col>
          <Col md={5} sm={12} className="text-center">
            <img
              src={require("../../assets/img/jumbo3.png")}
              className="img-fluid"
              alt="jumbo3"
            />
          </Col>
        </Row> */}
      </div>
      <div className="main_jumbotron bg-green">
        {/* <Row>
          <Col md={6} sm={12}>
            <p className="txt-above">Over The Moon</p>
            <h1 className="mb-3">오버더문에듀</h1>
            <p className="txt-below">1:1 유학매칭 에듀 플랫폼</p>
          </Col>
          <Col md={3} sm={6} className="text-center">
            <img
              src={require("../../assets/img/jumbo4.png")}
              className="img-fluid"
              alt="jumbo4"
            />
          </Col>
          <Col md={3} sm={6} className="text-center">
            <img
              src={require("../../assets/img/jumbo1.png")}
              className="img-fluid"
              alt="jumbo1"
            />
          </Col>
        </Row> */}
      </div>
    </Carousel>
  );
};

export default JumboCarousel;
